import EnterPhone from "./EnterPhone";

export default EnterPhone;
